module.exports = __webpack_public_path__ + "img/LogoDashboard-8.5e7f6190.svg";